import { graphemeSlice } from "../emoji/graphemes";

/** Length in Unicode code points (the unit every server limit uses), not UTF-16 units. */
export const codePointLength = (s: string): number => Array.from(s).length;

/** The first `max` code points of `s` + "…" when it is longer; never splits a character (emoji with joiners stay whole or are dropped). */
export function truncateCodePoints(s: string, max: number): string {
  return codePointLength(s) > max ? graphemeSlice(s, max) + "…" : s;
}
